import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    documents:null,
    loading: false,
    error:null
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.FETCH_DOCUMENTS_BEGIN:
            return updateObject(state, {loading:true, error:null});
        case actionTypes.FETCH_DOCUMENTS_SUCCESS: 
            return updateObject(state, {loading:false, documents:action.payload.documents});
        case actionTypes.FETCH_DOCUMENTS_FAILED: 
            return updateObject(state, {loading:false, error:action.payload.error, documents:null});
        default: 
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/document.js